export const parseToNumberOrNull = (value: unknown) => {
  const numValue = Number(value);
  return isNaN(numValue) ? null : numValue;
};
